<template>
  <div class="generic-task-container">
    <div v-if="isFeedMode" class="next-task-button-wrapper">
      <button @click="goToNextTask" class="next-task-button">
        <span class="button-icon">➡️</span>
        <span>מעבר למשימה הבאה</span>
      </button>
    </div>

    <div class="task-card">
      <div class="task-icon">📋</div>
      <h2 class="task-title">{{ taskName }}</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GenericTask',
  props: {
    taskName: {
      type: String,
      required: true
    },
    isFeedMode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goToNextTask () {
      this.$emit('go-to-next-task')
    }
  }
}
</script>

<style scoped>
.generic-task-container {
  padding: 12px;
  background: #ffffff;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

/* Next Task Button */
.next-task-button-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 8px 0;
}

.next-task-button {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 24px;
  background: linear-gradient(135deg, #4caf50 0%, #45a049 100%);
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.next-task-button:hover {
  background: linear-gradient(135deg, #45a049 0%, #3d8b40 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(76, 175, 80, 0.4);
}

.next-task-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);
}

.button-icon {
  font-size: 1.3rem;
  animation: slideRight 1.5s ease-in-out infinite;
}

@keyframes slideRight {
  0%, 100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(5px);
  }
}

.task-card {
  width: 100%;
  max-width: 450px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  padding: 32px 24px;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.35);
  color: white;
  text-align: center;
  animation: fadeIn 0.5s ease;
  position: relative;
  overflow: hidden;
  min-height: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.task-card::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
    45deg,
    transparent,
    rgba(255, 255, 255, 0.1),
    transparent
  );
  animation: shine 3s infinite;
}

@keyframes shine {
  0% {
    transform: translateX(-100%) translateY(-100%) rotate(45deg);
  }
  100% {
    transform: translateX(100%) translateY(100%) rotate(45deg);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.task-icon {
  font-size: 3.5rem;
  margin-bottom: 20px;
  animation: bounce 2s infinite;
  position: relative;
  z-index: 1;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.task-title {
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  position: relative;
  z-index: 1;
  line-height: 1.4;
}

/* Responsive Design */
@media (max-width: 768px) {
  .task-card {
    padding: 24px 18px;
    max-width: 100%;
    min-height: 120px;
  }

  .task-icon {
    font-size: 2.8rem;
    margin-bottom: 16px;
  }

  .task-title {
    font-size: 1.4rem;
  }

  .next-task-button {
    padding: 10px 20px;
    font-size: 1rem;
  }
}
</style>
